<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="approvalConsumablesTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="wtFormTableListButtonsAfter" slot-scope="scope">
           <wt-auth v-if="scope.row.state === 2" :hasAnyPremission="form.formCode + ':APPROVAL'" class="search-form-btn">
             <el-button size="mini" type="primary" @click="toClickAction(scope.row, 'APPLY')">审批</el-button>
           </wt-auth>
           <wt-auth v-if="scope.row.state === 3" :hasAnyPremission="form.formCode + ':OUT'" class="search-form-btn">
             <el-button size="mini" type="primary" @click="toClickAction(scope.row, 'OUT')">发货</el-button>
           </wt-auth>
        </template>
      </wt-form-table-list>
    </wt-form-table>
    <approval-manage-reason-page
      :visible.sync="applyDialogVisible"
      @refreshData="$refs.approvalConsumablesTableRef.requestList()"
    ></approval-manage-reason-page>
    <el-dialog
      title="发货信息"
      :visible.sync="outDialog.visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
      key="2"
      :modal="false"
      :before-close="handleOutDialogClose">
      <div>
        <el-table :data="outDialog.data" border style="width: 100%">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column key="name" prop="name" label="耗材名称"></el-table-column>
          <el-table-column key="count" prop="count" label="申请数量"></el-table-column>
          <el-table-column prop="countReal" label="发货数量">
            <template slot-scope="data">
              <el-input type="text" v-model="data.row.countReal" :placeholder="'请输入'"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleOutDialogClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submitOutForm">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ApplyManageConsumables',
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_APPLY_CONSUMABLES',
        formComponent: {
          view: { type: 'component', componentName: 'ApprovalManageViewPage', value: 'queryApprovalDetailData' },
          list: { type: 'default', value: '/modules/approve/approveList', params: { type: 2 }}
        },
        formInputsData: [{ name: '申请编号', key: 'id', value: '', type: 'text' },
          { name: '站点名称', key: 'siteName', value: '', type: 'text' },
          { name: '社区', key: 'communityName', value: '', type: 'text' },
          { name: '站长姓名', key: 'employeesName', value: '', type: 'text' },
          { name: '状态',
            key: 'state',
            value: '',
            type: 'select',
            data: [
              { label: '全部', value: '' },
              { label: '等待区域负责人审批', value: 1 },
              { label: '等待平台审批', value: 2 },
              { label: '待发货', value: 3 },
              { label: '待收货', value: 4 },
              { label: '部分收货', value: 6 },
              { label: '全部收货', value: 7 },
              { label: '区域负责人拒绝', value: 8 },
              { label: '平台拒绝', value: 9 },
              { label: '审批通过', value: 10 },
              { label: '已完成', value: 11 }
            ] },
          { name: '申请时间', key: 'updateTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/approve/approveListImport',
          fileName: '耗材审批',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '申请编号', key: 'id', type: 'text' },
          { name: '站点名称', key: 'siteName', type: 'text' },
          { name: '站点地址', key: 'siteAddress', type: 'text' },
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '申请人', key: 'employeesName', type: 'text' },
          { name: '申请时间', key: 'siteApproveTime', type: 'text', sortable: 'custom' },
          { name: '区域负责人', key: 'areaManagerName', type: 'text' },
          { name: '审批时间', key: 'areaManagerApproveTime', type: 'text', sortable: 'custom' },
          { name: '平台负责人', key: 'systemName', type: 'text' },
          { name: '审批时间', key: 'systemApproveTime', type: 'text', sortable: 'custom' },
          { name: '收货人', key: 'operatorName', type: 'text' },
          { name: '收货时间', key: 'operatorTime', type: 'text', sortable: 'custom' },
          { name: '状态', key: 'stateName', type: 'text' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' }],
        formResult: { },
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true }
      },
      applyDialogVisible: false,
      outDialog: {
        visible: false,
        row: {},
        data: []
      },
      currentRow: {}
    }
  },
  methods: {
    onButtonAction() {},
    toClickAction(row, type) {
      const that = this
      if (type === 'APPLY') {
        that.$store.dispatch('queryApprovalDetailData', row.id)
        that.applyDialogVisible = true
      }
      if (type === 'OUT') {
        that.outDialog.data = []
        that.$store.dispatch('queryApprovalDetailData', row.id).then(res => {
          that.outDialog.row = JSON.parse(JSON.stringify(res))
          if (res.approveDetailConsumables) {
            that.outDialog.data = res.approveDetailConsumables
          }
          that.outDialog.visible = true
        })
      }
    },
    submitOutForm() {
      for (const item of this.outDialog.data) {
        if (this.$wtUtil.isBlank(item.countReal)) {
          this.$message.warning('请输发货数量')
          return
        }
        if (!this.$wtUtil.isGreaterZeroInt(item.countReal)) {
          this.$message.warning('请输入不小于0的整数')
          return
        }
        // if (item.countReal * 1 > item.count) {
        //   this.$message.warning('发货数量不能大于要货数量')
        //   return
        // }
      }
      this.outDialog.row.approveDetailConsumables = this.outDialog.data
      this.$api.approval.approveConsumablesAdd(this.outDialog.row).then(res => {
        this.$message({ message: '发货成功', type: 'success' })
        this.$refs.approvalConsumablesTableRef.requestList()
        this.handleOutDialogClose()
      })
    },
    handleOutDialogClose() {
      this.outDialog.visible = false
    }
  }
}
</script>

<style>
</style>
